import Component from "../abstracts/Component";
import {Matchmq} from "../utils/ResolutionHandler";
import { algoliaClickAfterSearch, algoliaAddToWishlist, algoliaAddToCart, storeAlgoliaAttributes } from "../utils/algoliaTrackings";
import Cookies from "js-cookie";
export default class TrackingComponent extends Component {

  get SELECTORS() {
    return {
      dataTracking: '[data-tracking-action]',
      fitersInput: '.js-filters-checkbox',
      trackingPayload: '[data-tracking-payload]',
      cartPage: '.t-cart',
      O2OCCSearchInput: '#sl__search__input',
      carouselTracking: '[data-carousel-tracking]',
      dataAlgoliaSearch: '[data-algolia-search]',
      productViewElements: '[data-tracking-action="productView"]'
    }
  }

  get trackingLabel(){
    return {
    NEW_ARRIVALS:"new_arrivals",
    OUR_FAVORITES:"our_favorites",
    PRICE_ASC:"price_asc",
    PRICE_DESC:"price_desc",
    REC_FOR_YOU:"rec_for_you",
    SALES:"sales",
    SOLR_SORTING:"solr_sorting",
    T2SELL_SORTING:"t2s_sorting",
    ALGOLIA_SORTING:"rec_for_you",
    }
  }

  getSortTypeTracking(sortValue) {
    if (!sortValue) {
        return '';
    }

    if (sortValue.startsWith('rank')) {
        return this.trackingLabel.REC_FOR_YOU;
    }

    switch (sortValue) {
        case 'new-arrival':
            return this.trackingLabel.NEW_ARRIVALS;
        case 'price-asc':
        case 'price-asc-sale':
            return this.trackingLabel.PRICE_ASC;
        case 'price-desc':
        case 'price-desc-sale':
            return this.trackingLabel.PRICE_DESC;
        case 'sale':
            return this.trackingLabel.SALES;
        case 'topRated':
        case 'target2sell':
            return this.trackingLabel.OUR_FAVORITES;
        case 'personalization':
            return this.trackingLabel.ALGOLIA_SORTING;
        default:
            return '';
    }
}

  // retrieve object/sub-object identified by [data-tracking-payload] attribute and parse them with .data() method
  // to retriieve product JSON
  getTrackingPayloadData(el, list) {
    let elements;

    if (list == true) {
      elements = $(el).find(this.SELECTORS.trackingPayload);
    } else {
      elements = $(el).closest(this.SELECTORS.dataTracking).find(this.SELECTORS.trackingPayload);
    }

    let products = [];
    elements.each(function () {
      products.push($(this).data());
    });
    return products;
  }

  constructor() {
    super();
    this.actions = {
      // action triggered on clicking on "view more" button in listing
      // template ajax/t-category.jsp should add html tag with product-related + SELECTORS.trackingPayload data attributes
      loadMore: (payload) => {
        if (payload != null) {
          const products = this.getTrackingPayloadData(payload, true);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          const product = products[0];
          if (typeof product.template !== 'undefined') {
            //track only listing
            if (product.template !== "search-page") {
              try {
                this.log("tracking loadMore event with " + products.length + " more products");
                window.listViewMore(products);
              } catch (e) {
                this.log("listViewMore tracking function not available");
              }
            }
          }
        }
      },

      // from category listing or search listin on clicking product box
      productView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          // looking for first children of [data-tracking-action] el, with [data-tracking-payload] data attribute
          let product = products[0];
          // TODO: add other templates..
          if (typeof product.template !== 'undefined') {
            let carousel = el.closest(this.SELECTORS.carouselTracking);
            if ("category-page" == product.template || "na:t-editorial-listing" == product.template || "na:t-editorial" == product.template) {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            } else if (product.template === "product-page" && carousel && carousel.dataset.carouselTracking === "recommendation-engine") {
              try {
                this.log("tracking listCarouselClick event for product: " + product.id);
                window.listCarouselClick("recommendation-engine", product);
              } catch (e) {
                this.warn("listCarouselClick tracking function not available");
              }
            } else if ("search-page" == product.template) {
              try {
                this.log("tracking searchProdClick event for product: " + product.id);
                window.searchProdClick(product);
              } catch (e) {
                this.warn("searchProdClick tracking function not available");
              }
            } else {
              try {
                this.log("tracking listProdClick event for product: " + product.id);
                window.listProdClick(product);
              } catch (e) {
                this.warn("listProdClick tracking function not available");
              }
            }
          }
          let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId || document.querySelector('[data-algolia-search]')?.dataset?.algoliaSearch;
          if (!algoliaQueryId || algoliaQueryId == "") {
            console.warn("Algolia query ID not found");
          } else{
            // store algolia query id in localStorage before changing page
            storeAlgoliaAttributes();
            // send click event to Algolia
            algoliaClickAfterSearch(product, product.position + 1);
          }
        }
      },
      lookView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick('complete-the-look', product);
          } catch (e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      //tracks products in HP/Editorial components
      carouselView: (params, el) => {
        if (el) {
          let products = this.getTrackingPayloadData(el, false);
          if (products.length == 0) {
            this.warn("no products loaded");
            return;
          }
          let product = products[0];
          let carouselName = product.parentName;
          //fallback in case of empty name
          if (carouselName == '' || carouselName == 'undefined') {
            carouselName = 'generic';
          }
          try {
            this.log("tracking listCarouselClick event for product: " + product.id);
            window.listCarouselClick(carouselName, product);
          } catch (e) {
            this.warn("listCarouselClick tracking function not available");
          }
        }
      },
      wishlistAdd: (params, button) => {
        let productCode = params.code;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to wishlist event with code: ' + productCode);
          utag.wishlist_add(productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }

        // algolia tracking
        let algoliaQueryId = document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId || document.querySelector('[data-algolia-query-id]')?.dataset?.algoliaQueryId;
        if (!algoliaQueryId || algoliaQueryId == "") {
          console.warn("Algolia query ID not found");
        } else{
          algoliaAddToWishlist(productCode);
        }
      },
      //called from AddToCartComponent.js
      addToCart: (params) => {
        let productCode = params.productCode || params;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking add to cart event with code: ' + productCode);
          utag.cart_add(';' + productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
        // algolia tracking
        algoliaAddToCart(productCode);
      },
      addGiftcardToCart: params => {
        if (typeof params.value === 'undefined') {
          this.warn('no valid giftcard');
          return;
        }
        try {
          this.log('tracking add giftcard to cart event with code: ' + params.code);
          var link_data = new Object();
          link_data['event_category'] = 'gift card';
          link_data['event_action'] = 'add to cart';
          link_data['event_label'] = 'giftcart ' + params.value;
          link_data['event_type'] = 'giftcart_add_to_cart';
          utag.link(link_data);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      whatsappStart: () => {
        utag.link({
          event_name: "whatsapp_start"
        });
      },
      removeProduct: (params) => {
        let productCode = params.productcode;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        try {
          this.log('tracking removeProduct event with productCode: ' + params.productcode);
          utag.cart_remove_click(productCode);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      removeQuantity: (params) => {
        let productCode = params.productcode;
        let price = params.price;
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking removeQuantity event with productCode: ' + params.productcode);
          utag.cart_minus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      addQuantity: (params) => {
        let productCode = params.productCode
        let price = params.price
        if (typeof productCode === 'undefined') {
          this.warn('no productCode found');
          return;
        }
        if (typeof price === 'undefined') {
          this.warn('no price found');
          return;
        }
        try {
          this.log('tracking addQuantity event with productCode: ' + params.productCode);
          utag.cart_plus_click(productCode, 1, price);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      newsletter: (params) => {
        const pos = params.pos;
        const type = params.type ? "-" + params.type : '';
        this.log('[Tracking] NL-Subscription, type: ' + type + ' pos: ' + pos);
        ga('send', 'event', 'NL', 'NL-Subscription' + type, pos);
      },
      formisimo: (params) => {
        this.log("formisimo: ", params);
        if (typeof window.TealiumConversionForm == "function") {
          this.log("TealiumConversionForm: ", params);
          window.TealiumConversionForm(params.formId, params.result);
        } else {
          //keep data in a global var
          window.Tealium.trackingData = {
            formId: params.formId,
            formResult: params.result
          }
        }
      },
      sizeSelection: (params) => {
        let code = params.productCode;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking sizeSelection event with code: ' + code);
          utag.size_selection();
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      notifyMe: (params) => {
        let code = params;
        if (typeof code === 'undefined') {
          this.warn('no code found');
          return;
        }
        try {
          this.log('tracking back in stock event with code: ' + code);
          utag.back_in_stock();
        } catch (e) {
          this.warn('Utag tracking is not available');
        }
      },
      O2OCCSelect: (params) => {
        if (!this.isCartPage()) {
          return;
        }
        try {
          this.log('tracking 020 CC selected event');
          utag.click_collect('click');
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSearch: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let o2oCCSearchInput = $(this.SELECTORS.O2OCCSearchInput).val();
        try {
          this.log('tracking 020 CC store search event: ' + o2oCCSearchInput);
          utag.click_collect(o2oCCSearchInput);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCLocalize: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        try {
          this.log('tracking 020 CC localize event');
          utag.click_collect('localizza');
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      O2OCCSelectStore: (params) => {
        if (!this.isCartPage()) {
          return;
        }

        let storeName = params.storeName;
        if (typeof storeName === 'undefined') {
          this.warn('no storeName found');
          return;
        }
        try {
          this.log('tracking 020 CC store select event: ' + storeName);
          utag.click_collect("store:" + storeName);
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
      //called from FiltersComponent.js
      filterTracking: (params, orderBy) => {
        let facetCode = $(params).attr("data-facet-code") || params;
        let facetValue = $(params).attr("data-code") || orderBy;
        let facetV = undefined;
        this.log("Triggering filter");
         if (orderBy === true) {
          facetCode = "orderBy";
          facetValue = $(params).attr("data-sortby-name");
          facetV = $(params).attr("value");
          let sorting_method = "";
          if(facetV.includes("rank")){
            sorting_method = "t2s_sorting";
          } else if (facetV.includes('personalization')){
            sorting_method = "algolia_sorting";
          } else {
            sorting_method = "solr_sorting";
          }
          //utag_data update needed for the page reload
          utag_data['sorting_type'] = this.getSortTypeTracking(facetV);
          utag_data['sorting_method'] = sorting_method;

          this.log("Triggering filter sort " + facetCode + ": " + facetValue);
          console.log("value -> ",this.getSortTypeTracking(facetV));
          utag.link({
            filter: facetCode + ":" + facetValue,
            event_name: "filter_usage",
            sorting_method: sorting_method,
            sorting_type: this.getSortTypeTracking(facetV)
          });
        }

        if(facetValue != null && orderBy !== true) {
          this.log("Triggering filter" + facetCode + ": " + facetValue);
          try {
            this.log('tracking link event: ' + facetValue);
            utag.link({
              filter: facetCode + ":" + facetValue,
              event_name: "filter_usage",
            });
          } catch(e) {
            this.warn("Utag tracking not available");
          }
        }
      },
      startChat: () => {
        utag.link({
          event_name: "chat_start"
        });
      },
      login: () => {
        utag.link({
          event_name: "login",
          login_type: "email"
        })
      },
      signup: (country) => {
        console.log(country);
        utag.link({
          event_name: "sign_up",
          event_method: "manual",
          store_country: country,
        })
      },
      deleteChat: () => {
        utag.link({
          event_name: "chat_delete"
        });
      },
      newsletterSubscribe: (trackingPosition) => {
        utag.link({
          event_name: "newsletter_subscribe",
          form_type: trackingPosition
        });
      },
      shortcutCategoryView: (params) => {
        try {
          this.log('Tracking shortcut category click: ' + params.shortcutLabel);
          var data = new Object();
          data['event_name'] = 'select_content';
          data['event_location'] = params.shortcutNumber; // es. shortcut-micro_1, shortcut-macro_4 …
          data['event_detail'] = params.shortcutLabel; // es. our selection, clothing, pantaloni, abiti, …
          data['content_type'] = params.shortcutType; // es. shortcut-micro, shortcut-macro…
          utag.link(data)
        } catch (e) {
          this.warn("Utag tracking not available");
        }
      },
    }
  }

  isCartPage() {
    let element = $(this.SELECTORS.cartPage);
    if (element.length > 0) {
      return true;
    }
    return false;
  }

  isLogged() {
    const locationPath = window.location + "";
    return locationPath.split("/")[3].split("?")[1] === "login=success";
  }

  getListString(codeList) {
    let listString = ";";

    $.each(codeList, function (index, value) {
      listString += value + ",;";
    });

    listString = listString.substr(0, listString.lastIndexOf(","));
    return listString;
  }

  getItemListName(carousel) {
    if (carousel == null) {
      this.log("carousel not found");
      return;
    }
    let carouselName = carousel.dataset.carouselTracking;
    //fallback in case of empty name
    if (carouselName === '' || carouselName === 'undefined') {
      carouselName = "generic";
    }
    try {
      let products = this.getTrackingPayloadData(carousel.children, true);
      if (products.length == 0 || typeof products === 'undefined') {
        this.log("no products found in " + carouselName + " carousel");
        return;
      }
      try {
        this.log("tracking '" + carouselName + "' carousel with " + products.length + " products");
        window.listCarouselImpression(carouselName, products);
      } catch (e) {
        this.warn("listCarouselImpression tracking not available");
      }
    } catch (e) {
      this.warn("carousel tracking not available");
    }
  }

  carouselOnLoad() {
    //tracks 'carousel', 'cross-categories' and 'complete-the-look' carousels
    document.querySelectorAll(this.SELECTORS.carouselTracking).forEach((carousel) => {
      let carouselName = carousel.dataset.carouselTracking;
      if(carouselName != "recommendation-engine") { //recommendation-engine tracking handled separately with events since it's an async component
        this.getItemListName(carousel);
      }
    });
  }

  trackAction(action, data, targetElement) {
    if (this.actions[action]) {
      if (typeof data['bs.tab'] != 'undefined') {
        delete data['bs.tab'];
      }
      this.log('[Tracking] tracking action caught: ' + action + ' - with params: ' + JSON.stringify(data));
      this.actions[action](data, targetElement);
    } else {
      this.warn('[Tracking] no tracking manager found for action ' + action);
    }
  }

  bindEvents() {
    this.$on('click', ({event}) => {
      if (!$(event.currentTarget).data('disabled') && $(event.currentTarget).data('trackingAction')) {
        let data = $(event.currentTarget).data();
        let action = data.trackingAction;
        this.trackAction(action, data, event.target);
      }
    }, 'body', this.SELECTORS.dataTracking);

    if (this.isLogged()) {
      this.trackAction('login');
    }
  }

  bindCustomEvents() {
    // ??? custom "track" events
    $('body').on('track', (e, action, params) => {
      const data = [].slice.call(arguments).splice(2);
      this.trackAction(action, data);
    });

    // custom productView events to detect non-primary pointing device button click
    let ctx = this;
    const productViewElements = document.querySelectorAll(this.SELECTORS.productViewElements);
    productViewElements.forEach(elem => {
      elem.addEventListener('auxclick', (event) => {
        // if button clicked is right button or middle button, we call productView
        if (event.button == 1 || event.button == 2) {
          ctx.actions.productView({}, elem);
        }
      });
      elem.addEventListener('contextmenu', (event) => {
        // if contextmenu is shown we trigger productView
        ctx.actions.productView({}, elem);
      });
    });
  }

  initiateTracking() {
    const ctx = this;
    const $formisimo = $('formisimo');
    window.Tealium = {};

    if ($formisimo.length > 0) {
      $formisimo.each(function () {
        const $this = $(this);
        const data = [{'formId': $this.data('formId'), 'result': $this.data('formResult')}];
        ctx.trackAction('formisimo', data);
      });
    }
  }

  render() {
    this.initiateTracking();
    this.bindEvents();
    this.bindCustomEvents();
    //tracks 'recommendation engine' carousels
    this.$on(this.$customEvents.CAROUSEL.carouselLoaded, ({event, payload}) => {
      if (!payload || !payload.carousel) {
        this.log('carousel not found');
        return;
      }
      this.getItemListName(payload.carousel);
    });
    window.addEventListener('load', (event) => {
      this.carouselOnLoad();
    });
  }
}
